<template>
  <div class="wrap wrap-intel">
    <div class="banner">
      <img src="@/assets/images/banner_12.png" class="img-fluid">
      <div class="banner-info">
        <div class="left">
          <h2>离心浓缩仪</h2>
          <p style="line-height: 2;font-size: 16px">离心浓缩仪采用离心力、真空和加热相结合的方法使样品中的溶剂快速蒸发，从而达到浓缩样品的作用。可广泛用于生物学、微生物学、生物化学、制药研究以及分析化学等诸多方面。</p>
        </div>
        <div class="img_a" style="width:35%"><img src="@/assets/img/设备及原料/仪器设备/离心浓缩仪.png" width="100%" class="product"></div>
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container container1">
      <div class="c-title">产品特点</div>
      <el-row :gutter="90" type="flex" align="middle">
        <el-col :span="8">
          <div class="tc"><img src="@/assets/img/设备及原料/仪器设备/离心浓缩仪.png" width="250"></div>
        </el-col>
        <el-col :span="16" class="right-col">
          <ul class="lists">
            <li>可设置32种不同程序</li>
            <li>除离心机主机外，配备独立冷阱、油泵等，可自由组装</li>
            <li>7英寸触摸屏显示：设备运行状况，程序组号、设定及实际转速，设定及实际温度，设定时间及运行时间</li>
            <li>快插式转子设计，能快速更换不同转子，转子一体成型无焊点</li>
            <li>高透钢化玻璃盖板，便于观察蒸发情况</li>
            <li>离心成像功能，可在不停机的状态下观察样品浓缩情况</li>
          </ul>
        </el-col>
      </el-row>
    </section>
    <section class="container">
       <div class="dispose">
        <div class="title">标准配置</div>
        <el-row class="text-row">
          <el-col :span="24" class="list-item"><div><span class="circle"></span>离心浓缩仪 1台</div></el-col>
        </el-row>
      </div>
   </section>
    <section class="container">
      <div class="c-title">性能参数</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%; height: 101px">转速</td>
              <td>0-2000r/min</td>
            </tr>
            <tr>
              <td>温度范围</td>
              <td>室温-100℃，0.1℃递增</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">转头容量</td>
              <td style="text-align: center;">
                <div>184*1.5mL/2mL、132*1.5/2mL、</div>
                <div>72*5mL、24*15mL、12*50mL、</div>
                <div> 8*100mL、4*250mL、2*96孔板</div>
               
                
             </td>
            </tr>
            <tr>
              <td>槽体积</td>
              <td>3L</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </section>
  </div>
</template>
<style scoped>
@import url("../../assets/akta.css");
</style>
<style scoped lang="scss">
  .lists{
    display: unset !important;
    li{
      text-align: left;
    }
  }
  /deep/.right-col{
    padding: 0 !important;
  }
  .center-ele{
  margin-left: 100px;
  text-align: center;
  font-weight: bold;
}
.desc-ch{
  margin-top:-35px;
}
.desc-eh{
  margin-top:-16px;
}
.text-desc-list{
  padding-left: 26px;
}
.list-item{
  position: relative;
  padding-left: 20px !important;
}
.circle{
  display: inline-block;
  background: #014492;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 20px;
  position: absolute;
  left: 0px;
  top:4px;
}
.text-row{
  padding:10px 0;
}
</style>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/CTT.vue